export default __webpack_public_path__ + "static/UN_POLLO-48e13f279644c89eea8b7b226e34fc24.jpg";